export default __webpack_public_path__ + "static/02-44578792fcac5387b2053a914aa682b0.png";